// src/pages/Welcome/CTASection.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { COLORS, TYPOGRAPHY, LAYOUT } from '../../constants';
import { TrendingUpIcon, UsersIcon } from '../../components/Icons';

const CTASection = ({ user }) => {
  const navigate = useNavigate();

  const sectionStyle = {
    padding: `${LAYOUT.sectionSpacing} ${LAYOUT.containerPadding}`,
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, ${COLORS.primaryDark} 100%)`,
    position: 'relative',
    overflow: 'hidden',
  };

  const containerStyle = {
    maxWidth: LAYOUT.maxWidth,
    margin: '0 auto',
    textAlign: 'center',
    position: 'relative',
    zIndex: 2,
  };

  const titleStyle = {
    ...TYPOGRAPHY.heading1,
    color: COLORS.white,
    fontSize: 'clamp(2.5rem, 5vw, 3.5rem)',
    fontWeight: '700',
    marginBottom: LAYOUT.spacing.lg,
    lineHeight: '1.2',
  };

  const subtitleStyle = {
    ...TYPOGRAPHY.body,
    color: 'rgba(255, 255, 255, 0.9)',
    fontSize: 'clamp(1.1rem, 2.5vw, 1.4rem)',
    lineHeight: '1.6',
    marginBottom: LAYOUT.spacing.xxl,
    maxWidth: '600px',
    margin: `0 auto ${LAYOUT.spacing.xxl} auto`,
  };

  const buttonsContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: LAYOUT.spacing.lg,
    alignItems: 'center',
    maxWidth: '400px',
    margin: '0 auto',
  };

  const primaryButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: LAYOUT.spacing.sm,
    padding: `${LAYOUT.spacing.lg} ${LAYOUT.spacing.xl}`,
    backgroundColor: COLORS.white,
    color: COLORS.primary,
    fontSize: '18px',
    fontWeight: '600',
    borderRadius: LAYOUT.borderRadius.lg,
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
    width: '100%',
    justifyContent: 'center',
    textDecoration: 'none',
  };

  const secondaryButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: LAYOUT.spacing.sm,
    padding: `${LAYOUT.spacing.lg} ${LAYOUT.spacing.xl}`,
    backgroundColor: 'transparent',
    color: COLORS.white,
    fontSize: '16px',
    fontWeight: '600',
    borderRadius: LAYOUT.borderRadius.lg,
    border: `2px solid ${COLORS.white}`,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    width: '100%',
    justifyContent: 'center',
    textDecoration: 'none',
  };

  const backgroundPatternStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: `
      radial-gradient(circle at 20% 80%, rgba(249, 208, 22, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%)
    `,
    zIndex: 1,
  };

  const handleGetStarted = () => {
    if (user) {
      navigate('/market');
    } else {
      navigate('/login');
    }
  };

  const handleBrowse = () => {
    navigate('/market');
  };

  return (
    <section style={sectionStyle}>
      <div style={backgroundPatternStyle} />
      
      <div style={containerStyle}>
        <h2 style={titleStyle}>
          Ready to Join Redbird Markets?
        </h2>
        
        <p style={subtitleStyle}>
          Start buying and selling with your trusted ISU community today. 
          Connect with fellow Redbirds and discover amazing deals on campus.
        </p>

        <div style={buttonsContainerStyle}>
          <button
            style={primaryButtonStyle}
            onClick={handleGetStarted}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px) scale(1.02)';
              e.target.style.boxShadow = '0 12px 48px rgba(0, 0, 0, 0.3)';
              e.target.style.backgroundColor = COLORS.grayLight;
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0) scale(1)';
              e.target.style.boxShadow = '0 8px 32px rgba(0, 0, 0, 0.2)';
              e.target.style.backgroundColor = COLORS.white;
            }}
          >
            <TrendingUpIcon size={20} />
            {user ? 'Start Shopping' : 'Get Started Free'}
          </button>

          <button
            style={secondaryButtonStyle}
            onClick={handleBrowse}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = COLORS.white + '20';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            <UsersIcon size={20} />
            Browse Marketplace
          </button>
        </div>

        <div style={{
          marginTop: LAYOUT.spacing.xl,
          fontSize: '14px',
          color: COLORS.white + 'C0',
          fontWeight: '500',
        }}>
          Exclusive to verified ISU community members
        </div>
      </div>
    </section>
  );
};

export default CTASection;